import { __assign } from "tslib";
import { ApiTypes } from './sdk.types';
var ClientSearchBuilder = /** @class */ (function () {
    function ClientSearchBuilder() {
        this.searchResponse = {
            documents: [],
            facets: [],
            nextPage: {
                total: 0,
                skip: 0,
                limit: 25,
            },
        };
        this.documentTypesResponse = {
            sources: [],
        };
    }
    ClientSearchBuilder.prototype.withDocuments = function (count, callback) {
        if (!this.searchResponse) {
            throw new Error('This builder has no search response (e.g. `.withoutResponse()` method was called)');
        }
        if (count === 0) {
            this.searchResponse.documents = [];
            return this;
        }
        this.searchResponse.documents = new Array(count)
            .fill(undefined)
            .map(function (value, index) {
            var itemBuilder = new ClientSearchDocumentBuilder();
            return __assign({}, callback(itemBuilder, index));
        });
        return this;
    };
    ClientSearchBuilder.prototype.withFacets = function (facets) {
        if (!this.searchResponse) {
            throw new Error('This builder has no search response (e.g. `.withoutResponse()` method was called)');
        }
        this.searchResponse.facets = facets;
        return this;
    };
    ClientSearchBuilder.prototype.withPagination = function (nextPage) {
        if (!this.searchResponse) {
            throw new Error('This builder has no search response (e.g. `.withoutResponse()` method was called)');
        }
        this.searchResponse.nextPage = nextPage;
        return this;
    };
    ClientSearchBuilder.prototype.withoutResponse = function () {
        this.searchResponse = undefined;
        return this;
    };
    ClientSearchBuilder.prototype.withDocumentTypes = function (sources) {
        this.documentTypesResponse.sources = sources;
        return this;
    };
    ClientSearchBuilder.prototype.getSearchResponse = function () {
        return this.searchResponse;
    };
    ClientSearchBuilder.prototype.getDocumentTypesResponse = function () {
        return this.documentTypesResponse;
    };
    return ClientSearchBuilder;
}());
export { ClientSearchBuilder };
var ClientSearchDocumentBuilder = /** @class */ (function () {
    function ClientSearchDocumentBuilder() {
        this.document = {
            id: '61312e36-661f-11eb-ae93-0242ac130002',
            title: 'Demo title',
            description: 'Demo long content',
            documentType: ApiTypes.SearchDocumentType.Pages,
            url: '/test-url',
            _highlights: {},
            documentImage: {
                name: 'img.png',
                width: 400,
                height: 400,
            },
        };
    }
    ClientSearchDocumentBuilder.prototype.withDocumentType = function (documentType) {
        this.document.documentType = documentType;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withTitle = function (title) {
        this.document.title = title;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withPrice = function (price) {
        this.document.discountedPrice = price;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withDescription = function (description) {
        this.document.description = description;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withUrl = function (url) {
        this.document.url = url;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withImage = function (image) {
        this.document.documentImage = image;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.withHighlights = function (highlights) {
        this.document._highlights = highlights;
        return this;
    };
    ClientSearchDocumentBuilder.prototype.getResponse = function () {
        return this.document;
    };
    return ClientSearchDocumentBuilder;
}());
export { ClientSearchDocumentBuilder };
//# sourceMappingURL=sdk.builder.js.map